import { Box } from '@hivebrite/design-system/Box';

import { StyledHtml } from './StyledHtml';
import { getWrapperTextStyle } from '../utils/style';

export const SimpleText = ({
  attributes,
  canUpdateTextBackground,
  children,
  networkFont,
  theme,
}) => (
  <Box
    data-testid="builder-component-text"
    style={getWrapperTextStyle({
      attributes,
      canUpdateTextBackground,
      networkFont,
      theme,
    })}
  >
    <StyledHtml
      data-testid="builder-component-text-html"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: children }}
    />
  </Box>
);
